{
    "Policies_Header.title": "FR: Policies",

    "Policies_Header.nav.all": "FR: All",
    "Policies_Header.nav.incomplete": "FR: Incomplete",
    "Policies_Header.nav.bound": "FR: Bound",
    "Policies_Header.nav.board": "FR: Board",

    "Policies_Header.filter.brokerage": "FR: Brokerage",
    "Policies_Header.filter.assignedTo": "FR: Assigned To",

    "Policies_Header.filter.showSuspended": "FR: Show suspended",
    "Policies_Header.filter.showSuspendedDescription": "FR: This option will show suspended leads in addition to any other filtering criteria.",
    "Policies_Header.filter.showUnassigned": "FR: Show unassigned",
    "Policies_Header.filter.showUnassignedDescription": "FR: This option will show unassigned leads in addition to any other filtering criteria."
}
